import {ObjectDocumentAssocEntity} from "@ots-frontend/ots-data";
import {BaseEntitySelect, BaseEntitySelectProps} from "../base-entity-select";
import {useTranslation} from "react-i18next";
import {useCallback} from "react";
import { getFormattedDateTime } from "../../../date/FormattedDateTime/FormattedDateTime";

export type BaseObjectDocumentAssocSelectProps = Omit<BaseEntitySelectProps<ObjectDocumentAssocEntity>, 'placeholder' | 'nameMapper'> & {
  placeholder?: string
  showDate?: boolean
};

export const BaseObjectDocumentAssocSelect = (props: BaseObjectDocumentAssocSelectProps) => {
  const {t} = useTranslation(["common"])

  const {
    placeholder = t<string>("common.entity.objectdocumentassoc", "Document"),
    showDate = true,
  } = props

  // name mapper
  const nameMapper = useCallback(
    (e: ObjectDocumentAssocEntity) => {
      let name = e.fileName ?? e.description ?? t<string>("common.shared.unknown")
      if (showDate && e.createDttm) {
        name += " ("
        name += getFormattedDateTime(e.createDttm)
        name += ")"
      }
      return name
    },
    [showDate, t]
  );

  return <BaseEntitySelect {...props} placeholder={placeholder} nameMapper={nameMapper}/>;
};
